import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Box from "@material-ui/core/Box";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { withStyles } from "@material-ui/core/styles";

import Button from "../../../../../../../../ui/Button";

const DialogTitle = withStyles(theme => ({
  root: {
    color: "#778899",
    "& > h2": {
      fontSize: 12
    }
  }
}))(MuiDialogTitle);

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    display: "flex"
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: "16px",
    "& > button:first-of-type": {
      marginRight: 4
    }
  }
}))(MuiDialogActions);

export default function roomDialog({
  type,
  title,
  showRoomDialog,
  closeRoomDialog,
  allRoomTypesList,
  room,
  changeRoomType,
  changeRoomDescription,
  lessonId,
  roomId,
  addModuleRoomList,
  updateModuleRoom
}) {
  const addRoom = () => {
    const moduleRoom = {
      lessonId: lessonId,
      main: {
        type: room.main.type,
        description: room.main.description
      }
    };
    addModuleRoomList(moduleRoom);
    closeRoomDialog();
  };

  const updateRoom = () => {
    const moduleRoom = {
      main: {
        type: room.main.type,
        description: room.main.description
      }
    };
    updateModuleRoom(roomId, moduleRoom);
    closeRoomDialog();
  };

  return (
    <div>
      <Dialog open={showRoomDialog} PaperProps={{ style: { minWidth: 400 } }}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Grid container justify="space-between">
            <Grid item xs={12}>
              <Box mb={1}>
                <Autocomplete
                  options={allRoomTypesList}
                  disableClearable
                  getOptionLabel={option => (option ? option.name : option)}
                  value={
                    room &&
                    (allRoomTypesList.find(
                      item => item.id === room.main.type
                    ) ||
                      "")
                  }
                  onChange={(event, item) => changeRoomType(event, item.id)}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Вид помещения"
                      InputLabelProps={{
                        shrink: true
                      }}
                      fullWidth
                      required
                    />
                  )}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box>
                <TextField
                  name="description"
                  required
                  label="Краткое описание"
                  value={room && room.main.description}
                  onChange={changeRoomDescription}
                  InputLabelProps={{
                    shrink: true
                  }}
                  fullWidth
                  multiline
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={closeRoomDialog}>Отмена</Button>
          <Button
            onClick={() => (type === "add" ? addRoom() : updateRoom())}
            color="green"
          >
            {type === "add" ? "Добавить" : "Обновить"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
